import { Button, CircularProgress, Divider, Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/system";
import React, { useState, useCallback, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Webcam from "react-webcam";
import Dropzone from "../../Components/Dropzone/Dropzone";
import { updateSelfie } from "../../redux/user/userSlice";
import { API } from "../../utils/http";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
export default function PicturesUpload(props) {
	const { handleNext, handleBack, renderControls, verifier } = props;
	const [error, setError] = useState({});
	const [webcamLoaded, setwebcamLoaded] = useState(false);
	const [hasChanged, setHasChanged] = useState(false);
	const selfie = useSelector((state) => state.user.application.selfie);
	const personalInformation = useSelector((state) => state.user.application.personalInformation);
	const { t } = useTranslation();
	const webcamRef = useRef(null);
	const dispatch = useDispatch();
	const capture = useCallback(() => {
		setError({});
		setHasChanged(true);
		const imageSrc = webcamRef.current.getScreenshot();
		dispatch(updateSelfie(imageSrc));
		setwebcamLoaded(false);
	}, [webcamRef]);

	const theme = useTheme();
	const handleNextButton = () => {
		if (!hasChanged && selfie) {
			handleNext();
			return;
		}
		console.log("send selfie img to backend: ", selfie);
		const errors = verifier(selfie);
		console.log(selfie);
		console.log(errors);
		if (Object.keys(errors).length == 0) {
			API.put("application", {
				id: personalInformation.id,
				pictures: [
					{
						type: "selfie",
						front: selfie,
					},
				],
			})
				.then((r) => {
					console.log(r);
					toast.success(t("Picture Upload Success"));
					handleNext();
				})
				.catch((e) => {
					console.log(e);
					toast.error(t("Picture Upload Fail"));
				});

			setError({});
		} else {
			setError(errors);
		}
	};
	const handleUserMedia = (e) => {
		console.log("loaded");
		setwebcamLoaded(true);
	};
	const handleUserMediaError = (e) => {
		console.log("loaded");
		setwebcamLoaded(true);
	};
	return (
		<React.Fragment>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography>{t("Picture Upload Line 1")}</Typography>
					<Typography>{t("Picture Upload Line 2")}</Typography>
				</Grid>
				<Grid item xs={12}>
					<Divider></Divider>
				</Grid>
				<Grid item xs={12} textAlign="center">
					{selfie === "" ? (
						<React.Fragment>
							<React.Fragment>
								<div style={{ position: "relative" }}>
									{webcamLoaded ? (
										<div
											style={{
												background: "rgba(0,0,0,0.2)",
												border: " 2px solid black",
												position: "absolute",
												width: "250px",
												transform: "translate(-50%,-50%)",
												top: "50%",
												left: "50%",
												zIndex: 100,
												borderRadius: "50%",
												maxWidth: "100%",
												aspectRatio: "1/1",
											}}
										></div>
									) : (
										<CircularProgress />
									)}
									<Webcam
										mirrored
										onUserMedia={handleUserMedia}
										onUserMediaError={handleUserMediaError}
										screenshotFormat="image/jpeg"
										ref={webcamRef}
										style={{ maxWidth: "100%", display: "block", margin: "0 auto 20px auto" }}
									/>
								</div>
								<Button variant="contained" onClick={capture} sx={{ textTransform: "capitalize" }}>
									{t("Capture Photo")}
								</Button>
							</React.Fragment>
						</React.Fragment>
					) : (
						<>
							<img src={selfie} alt="screenshot" style={{ maxWidth: "100%", display: "block", margin: "0 auto 20px auto" }} />
							<Button
								variant="contained"
								onClick={() => {
									setwebcamLoaded(false);
									dispatch(updateSelfie(""));
								}}
								style={{ textTransform: "capitalize" }}
							>
								{t("Retake")}
							</Button>
						</>
					)}
					<Typography sx={{ display: error.selfie ? "block" : "none", color: theme.palette.error.main, whiteSpace: "pre-line" }}>
						{"\n"}
						{error.selfie}
					</Typography>
				</Grid>
			</Grid>
			{renderControls(handleNextButton, handleBack)}
		</React.Fragment>
	);
}
